import React from 'react';
import {
  TrendingUp,
  AlertTriangle,
  DollarSign,
  BarChart3,
  ListOrdered,
} from 'lucide-react';

export interface Suggestion {
  icon: React.FC<{ className?: string }>;
  label: string;
  prompt: string;
}

const suggestions: Suggestion[] = [
  {
    icon: TrendingUp,
    label: 'Analyze spending trends',
    prompt:
      'Analyze my spending trends over the past 3 months and highlight any notable changes.',
  },
  {
    icon: AlertTriangle,
    label: 'Review unusual transactions',
    prompt:
      'Review my recent transactions and flag anything unusual or unexpected.',
  },
  {
    icon: DollarSign,
    label: 'Summarize cash flow',
    prompt:
      'Give me a summary of my current cash flow situation including income and expenses.',
  },
  {
    icon: BarChart3,
    label: 'Compare monthly revenue',
    prompt:
      'Compare my revenue this month to last month and explain any significant differences.',
  },
  {
    icon: ListOrdered,
    label: 'Check top expenses',
    prompt:
      'What are my top expense categories this month? Show me a breakdown.',
  },
];

interface SuggestedPromptsProps {
  onSelect: (prompt: string) => void;
}

const SuggestedPrompts: React.FC<SuggestedPromptsProps> = ({ onSelect }) => {
  return (
    <div className="grid grid-cols-2 sm:flex sm:flex-wrap sm:justify-center gap-2.5 w-full max-w-[680px]">
      {suggestions.map(({ icon: Icon, label, prompt }, index) => (
        <button
          key={label}
          onClick={() => onSelect(prompt)}
          className="flex items-center gap-2 h-10 px-4 rounded-xl border border-border bg-white text-sm font-medium text-foreground hover:border-primary dark:hover:border-primary/30 hover:bg-accent transition-colors duration-150"
          style={{
            opacity: 0,
            animation: `pill-in 300ms ease-out ${200 + index * 100}ms forwards`,
          }}
        >
          <Icon className="w-4 h-4 flex-shrink-0" />
          {label}
        </button>
      ))}
    </div>
  );
};

export default SuggestedPrompts;
